import React from "react";
import { Route } from "react-router-dom";

import App from "./components/App";
import Greetings from "./components/pages/Greetings";
import WhatAfter from "./components/pages/WhatAfter";
import Notes from "./components/pages/Notes";
import Summary from "./components/pages/Summary";
import Poll from "./components/pages/Poll";

export default (
  <App>
    <Route exact path="/" component={Greetings} />
    <Route exact path="/instrukcja" component={Notes} />
    <Route exact path="/co_dalej" component={WhatAfter} />
    <Route path="/ankieta" component={Poll} />
    <Route path="/koniec" component={Summary} />
  </App>
);



// WEBPACK FOOTER //
// ./src/routes.js